export const load = () => ({
	title: 'Magnetic Seal vs Compression Seal',
	showTitle: true,
});
